export const isInternetExplorer = () => {
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    return true;
  }

  if (navigator.userAgent.indexOf("MSIE") !== -1) {
    return true;
  }

  if (navigator.userAgent.indexOf("Trident/") !== -1) {
    return true;
  }

  return false;
};

export const isSamsungInternet = () => {
  const ua = navigator.userAgent;

  return (
    ua.includes("SamsungBrowser") ||
    ua.includes("SAMSUNG") ||
    ua.match(/SM-|SCH-|GT-/) !== null
  );
};

export const detectBrowser = () => {
  const ua = navigator.userAgent;

  return {
    isIE: isInternetExplorer(),
    isSamsungInternet: isSamsungInternet(),
    isOldAndroid: /Android [1-4]/.test(ua),
    isOldChrome: /Chrome\/[1-5][0-9]/.test(ua),
    isMobile: /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      ua,
    ),
    isAndroid: /Android/i.test(ua),
    isIOS: /iPhone|iPad|iPod/i.test(ua),
    userAgent: ua,
    needsCompatibilityFixes:
      isInternetExplorer() ||
      isSamsungInternet() ||
      /Android [1-4]/.test(ua) ||
      /Mobile/i.test(ua),
  };
};

export const isMobileDevice = () => {
  const browser = detectBrowser();
  return browser.isMobile;
};

export const shouldBlockBrowser = () => {
  const browser = detectBrowser();

  return browser.isIE || browser.isSamsungInternet;
};

export const logBrowserInfo = () => {
  const browser = detectBrowser();
  return browser;
};

export const getIEVersion = () => {
  if (!isInternetExplorer()) {
    return null;
  }

  const ua = navigator.userAgent;

  if (ua.indexOf("Trident/") !== -1) {
    const rv = ua.indexOf("rv:");
    if (rv !== -1) {
      return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
    }
  }

  const msie = ua.indexOf("MSIE ");
  if (msie !== -1) {
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  return null;
};

export const applyIEModalFixes = (modalElement) => {
  if (!isInternetExplorer() || !modalElement) {
    return;
  }

  modalElement.style.position = "fixed";
  modalElement.style.top = "0";
  modalElement.style.left = "0";
  modalElement.style.right = "0";
  modalElement.style.bottom = "0";
  modalElement.style.zIndex = "9999";
  modalElement.style.display = "-ms-flexbox";
  modalElement.style.display = "flex";
  modalElement.style.msFlexAlign = "center";
  modalElement.style.alignItems = "center";
  modalElement.style.msFlexPack = "center";
  modalElement.style.justifyContent = "center";
  modalElement.style.backgroundColor = "rgba(0, 0, 0, 0.75)";

  const modalContent = modalElement.querySelector(".ie-modal-content");
  if (modalContent) {
    modalContent.style.position = "relative";
    modalContent.style.maxWidth = "90%";
    modalContent.style.maxHeight = "90vh";
    modalContent.style.backgroundColor = "#ffffff";
    modalContent.style.borderRadius = "1rem";
    modalContent.style.boxShadow = "0 25px 50px -12px rgba(0, 0, 0, 0.25)";
    modalContent.style.overflow = "auto";
    modalContent.style.margin = "20px";
    modalContent.style.padding = "1.5rem";
    modalContent.style.border = "1px solid #f3f4f6";
  }
};

export const fixReactModalForIE = (modalRoot) => {
  if (!isInternetExplorer() || !modalRoot) {
    return;
  }

  const modals = modalRoot.querySelectorAll('[class*="ReactModal"]');

  modals.forEach((modal) => {
    modal.style.position = "fixed";
    modal.style.top = "0";
    modal.style.left = "0";
    modal.style.right = "0";
    modal.style.bottom = "0";
    modal.style.zIndex = "9999";
    modal.style.display = "-ms-flexbox";
    modal.style.display = "flex";
    modal.style.msFlexAlign = "center";
    modal.style.alignItems = "center";
    modal.style.msFlexPack = "center";
    modal.style.justifyContent = "center";
    modal.style.backgroundColor = "rgba(0, 0, 0, 0.75)";

    const content = modal.querySelector(
      '[class*="bg-white"], [class*="dark:bg-gray"]',
    );
    if (content) {
      content.style.position = "relative";
      content.style.maxWidth = "90%";
      content.style.maxHeight = "90vh";
      content.style.backgroundColor = "#ffffff";
      content.style.borderRadius = "1rem";
      content.style.boxShadow = "0 25px 50px -12px rgba(0, 0, 0, 0.25)";
      content.style.overflow = "auto";
      content.style.margin = "20px";
      content.style.padding = "1.5rem";
      content.style.border = "1px solid #f3f4f6";
    }
  });
};

export const initializeReactModalForIE = () => {
  if (!isInternetExplorer()) {
    return;
  }

  try {
    const Modal = require("react-modal");
    if (Modal && Modal.setAppElement) {
      Modal.setAppElement(document.body);
    }
  } catch (error) {}

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (
            node.classList &&
            (node.classList.contains("ReactModal__Overlay") ||
              node.getAttribute("class")?.includes("ReactModal") ||
              (node.getAttribute("class")?.includes("fixed") &&
                node.getAttribute("class")?.includes("inset-0")))
          ) {
            setTimeout(() => fixReactModalForIE(node), 10);
          }

          const modals =
            node.querySelectorAll &&
            node.querySelectorAll(
              '[class*="ReactModal"], [class*="fixed"][class*="inset-0"]',
            );
          if (modals && modals.length > 0) {
            modals.forEach((modal) => {
              setTimeout(() => fixReactModalForIE(modal), 10);
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

export const applyIEFlexboxFixes = (element) => {
  if (!isInternetExplorer() || !element) {
    return;
  }

  if (element.style.display === "flex") {
    element.style.display = "-ms-flexbox";
    element.style.display = "flex";
  }

  if (element.style.alignItems) {
    element.style.msFlexAlign = element.style.alignItems;
  }

  if (element.style.justifyContent) {
    element.style.msFlexPack = element.style.justifyContent;
  }

  if (element.style.flexDirection) {
    element.style.msFlexDirection = element.style.flexDirection;
  }
};

export const applyIETransformFixes = (element, transform) => {
  if (!isInternetExplorer() || !element) {
    return;
  }

  if (transform.includes("translateY(-50%)")) {
    element.style.marginTop = "-50%";
    element.style.transform = "none";
  }

  if (transform.includes("translateX")) {
    const match = transform.match(/translateX\(([^)]+)\)/);
    if (match) {
      element.style.marginLeft = match[1];
    }
  }
};

export const applyIEGridFixes = (element) => {
  if (!isInternetExplorer() || !element) {
    return;
  }

  const classList = element.classList;

  if (classList.contains("grid")) {
    element.style.display = "-ms-grid";
    element.style.display = "grid";
  }

  if (classList.contains("grid-cols-2")) {
    element.style.msGridColumns = "1fr 1fr";
    element.style.gridTemplateColumns = "repeat(2, 1fr)";
  }

  if (classList.contains("grid-cols-3")) {
    element.style.msGridColumns = "1fr 1fr 1fr";
    element.style.gridTemplateColumns = "repeat(3, 1fr)";
  }

  if (classList.contains("grid-cols-4")) {
    element.style.msGridColumns = "1fr 1fr 1fr 1fr";
    element.style.gridTemplateColumns = "repeat(4, 1fr)";
  }
};

export const disableIEDarkModeDetection = () => {
  if (!isInternetExplorer()) {
    return;
  }

  const html = document.documentElement;
  const body = document.body;

  html.classList.remove("dark");
  body.classList.remove("dark");

  html.classList.add("ie-force-light-mode");
  body.classList.add("ie-force-light-mode");

  if (window.matchMedia) {
    const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");

    darkModeQuery.addListener = () => {};
    darkModeQuery.addEventListener = () => {};
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const target = mutation.target;
        if (target.classList.contains("dark")) {
          target.classList.remove("dark");
        }
      }
    });
  });

  observer.observe(html, {
    attributes: true,
    attributeFilter: ["class"],
  });

  observer.observe(body, {
    attributes: true,
    attributeFilter: ["class"],
  });
};

export const initializeIECompatibility = () => {
  if (!isInternetExplorer()) {
    return;
  }

  disableIEDarkModeDetection();

  initializeReactModalForIE();

  document.body.classList.add("ie-browser");

  const modals = document.querySelectorAll(".ie-modal-overlay");
  modals.forEach(applyIEModalFixes);

  const flexElements = document.querySelectorAll(
    '[style*="display: flex"], .flex',
  );
  flexElements.forEach(applyIEFlexboxFixes);

  const gridElements = document.querySelectorAll(".grid");
  gridElements.forEach(applyIEGridFixes);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.classList && node.classList.contains("ie-modal-overlay")) {
            applyIEModalFixes(node);
          }

          if (node.classList && node.classList.contains("flex")) {
            applyIEFlexboxFixes(node);
          }

          if (node.classList && node.classList.contains("grid")) {
            applyIEGridFixes(node);
          }

          if (
            node.classList &&
            (node.classList.contains("ReactModal__Overlay") ||
              node.getAttribute("class")?.includes("ReactModal") ||
              (node.getAttribute("class")?.includes("fixed") &&
                node.getAttribute("class")?.includes("inset-0")))
          ) {
            setTimeout(() => fixReactModalForIE(node), 10);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

export const polyfillObjectAssign = () => {
  if (typeof Object.assign !== "function") {
    Object.assign = function (target) {
      if (target == null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }

      const to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        const nextSource = arguments[index];

        if (nextSource != null) {
          for (const nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    };
  }
};

export const polyfillArrayFrom = () => {
  if (!Array.from) {
    Array.from = function (arrayLike) {
      const result = [];
      for (let i = 0; i < arrayLike.length; i++) {
        result.push(arrayLike[i]);
      }
      return result;
    };
  }
};

polyfillObjectAssign();
polyfillArrayFrom();
